<template>
  <div>
    <template>
      <h4 class="not-margin" :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
        <i class="fal fa-ban" :style="{ width: '25px', fontSize: '18px' }"></i>
        ເພີ່ມ ສາຂາປາຍທາງທີ່ຖືກລັອກ
      </h4>
    </template>

    <div class="field" :style="{marginTop: '20px'}">
      <div class="control">
        <label class="label">
          ສາຂາປາຍທາງ (ຫ້າມສົ່ງເຂົ້າສູນນີ້)
          <span class="text-danger">* {{ errors.first('blockedBranchIds') }}</span>
          <span class="text-danger">{{ server_errors.branchIds }}</span>
        </label>
        <div :style="{marginTop: '5px'}">
          <vs-select
              filter multiple
              placeholder="ກະລຸນາເລືອກສາຂາປາຍທາງ..."
              name="blockedBranchIds"
              v-model="branchIds"
              v-validate="'required'">
            <vs-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in transformedBranches"
                :key="index">
              {{ item.name }}
            </vs-option>
          </vs-select>
        </div>
      </div>
    </div>

    <div class="field" :style="{marginTop: '20px'}">
      <div class="control">
        <label class="label">
          ຕົ້ນທາງທີ່ຖືກລັອກ (ສູນຄັດແຍກ) — ວ່າງ = ລັອກທຸກຕົ້ນທາງ
        </label>
        <div :style="{marginTop: '5px'}">
          <model-list-select
              :list="originOptions"
              v-model="originId"
              name="originId"
              placeholder="ທຸກຕົ້ນທາງ (ບໍ່ຈຳກັດ)"
              option-text="name"
              option-value="id"
              selectedItem="name">
          </model-list-select>
        </div>
      </div>
    </div>

    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button ref="button" flat @click="ValidateForm()" class="form-btn-loading" :loading="btnLoading">ບັນທຶກ
        </vs-button>
      </div>
    </div>

  </div>
</template>

<script>
import {ValidateDistributionCenter} from '@coms/../../src/Plugins/Validation/Validate-Distribution-Center';
import {ModelListSelect} from 'vue-search-select';

export default {
  components: {
    ModelListSelect,
  },

  props: ['branches', 'activeDistributionCenterId'],

  data: () => ({
    server_errors: {
      branchIds: '',
    },
    branchIds: [],
    originId: '', // '' = every origin (global block)
    distributionCenters: [],
    btnLoading: false,
  }),
  computed: {
    transformedBranches() {
      return this.branches.map((item) => {
        return {
          id: item.id,
          name: `${item.province ? item.province.prefix : ''}-${item.name}`,
        }
      });
    },
    // Searchable origin list with an explicit "all origins" sentinel first.
    // The destination DC itself is never a meaningful sending origin.
    originOptions() {
      const options = [{id: '', name: 'ທຸກຕົ້ນທາງ (ບໍ່ຈຳກັດ)'}];
      this.distributionCenters
          .filter((dc) => String(dc.id) !== String(this.activeDistributionCenterId))
          .forEach((dc) => options.push({id: dc.id, name: dc.name}));
      return options;
    }
  },
  methods: {
    FetchDistributionCenter() {
      this.$http.get('v1/listing/distribution_centers').then(res => {
        this.distributionCenters = res.data;
      }).catch(() => {
      });
    },
    ValidateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.SaveItem();
        }
      });
    },
    SaveItem() {
      this.btnLoading = true;
      this.$axios.post('add-distribution-center-blocked-branches/' + this.activeDistributionCenterId, {
        branchIds: this.branchIds,
        originId: this.originId,
      }).then(() => {
        this.btnLoading = false;
        this.$emit('close');
        this.$emit('success');
        this.$notification.OpenNotification_AddItem_OnSuccess('top-right', 'dark', 3000);
      }).catch((errors) => {
        this.btnLoading = false;
        if (errors.response?.status === 422) {
          this.server_errors.branchIds = 'ກະລຸນາເລືອກສາຂາຢ່າງໜ້ອຍ 1 ສາຂາ';
        } else {
          this.$notification.openNotification('ບໍ່ສາມາດເພີ່ມໄດ້ ເກີດຂໍ້ຜິດພາດ.',
              'top-right', 'danger', 5000);
        }
      });
    }
  },
  watch: {
    branchIds() {
      this.server_errors.branchIds = '';
    }
  },
  created() {
    ValidateDistributionCenter(this);
    this.FetchDistributionCenter();
  }
}
</script>

<style>

</style>
